// import React, { useState, useEffect } from "react";
// import { Table, Button, Form } from "react-bootstrap";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { useStateContext } from "../contexts/ContextProvider";

// const Log = () => {
//   const [logs, setLogs] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const logsPerPage = 10;
//   const { currentColor, currentMode } = useStateContext();

//   useEffect(() => {
//     const fetchLogs = async () => {
//       const data = [
//         {
//           createdOn: { $date: "2024-08-22T09:41:33.973Z" },
//           logLevel: "info",
//           clientId: { $oid: "669767918d2c855946168398" },
//           clientName: "localtest-bucket",
//           folderName: "test/ladder1/another/",
//           serverAddress: "100.71.105.206",
//           domain: "localhost",
//           apiPath: "/share/navigate/tGYhoZ",
//           message: "re-direct Success",
//           createdBy: "guest",
//           createdOnTimestamp: 1724319693973,
//         },
//         // Add more log entries here...
//       ];
//       setLogs(data);
//     };

//     fetchLogs();
//   }, []);

//   const filteredLogs = logs.filter((log) => {
//     const logDate = new Date(log.createdOn.$date);
//     return (
//       (!startDate || logDate >= startDate) && (!endDate || logDate <= endDate)
//     );
//   });

//   const indexOfLastLog = currentPage * logsPerPage;
//   const indexOfFirstLog = indexOfLastLog - logsPerPage;
//   const currentLogs = filteredLogs.slice(indexOfFirstLog, indexOfLastLog);

//   const handleNextPage = () => {
//     if (currentPage * logsPerPage < filteredLogs.length) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   return (
//     <div
//       className={`container  ${
//         currentMode === "dark" ? "bg-dark text-white" : " text-dark"
//       }`}
//       style={{ borderRadius: "10px", padding: "50px" }}
//     >
//       <div className="d-flex justify-content-between align-items-center mb-4">
//         <Form.Group className="d-flex align-items-center">
//           <Form.Label className="mr-2">Start Date:</Form.Label>
//           <DatePicker
//             selected={startDate}
//             onChange={(date) => setStartDate(date)}
//             className="form-control"
//             isClearable
//             placeholderText="Select start date"
//           />
//         </Form.Group>
//         <Form.Group className="d-flex align-items-center">
//           <Form.Label className="mr-2">End Date:</Form.Label>
//           <DatePicker
//             selected={endDate}
//             onChange={(date) => setEndDate(date)}
//             className="form-control"
//             isClearable
//             placeholderText="Select end date"
//           />
//         </Form.Group>
//         <span>
//           Showing {indexOfFirstLog + 1}-
//           {Math.min(indexOfLastLog, filteredLogs.length)} of{" "}
//           {filteredLogs.length} logs
//         </span>
//       </div>
//       <Table
//         striped
//         bordered
//         hover
//         responsive
//         className={`${currentMode === "dark" ? "table-dark" : "table-white"}`}
//       >
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Client Name</th>
//             <th>Folder Name</th>
//             <th>Server Address</th>
//             <th>Message</th>
//             <th>Created By</th>
//             <th>Created On (Timestamp)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentLogs.length > 0 ? (
//             currentLogs.map((log, index) => (
//               <tr key={index}>
//                 <td>{indexOfFirstLog + index + 1}</td>
//                 <td>{log.clientName}</td>
//                 <td>{log.folderName}</td>
//                 <td>{log.serverAddress}</td>
//                 <td>{log.message}</td>
//                 <td>{log.createdBy}</td>
//                 <td>{log.createdOnTimestamp}</td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="7" className="text-center">
//                 No logs available
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </Table>
//       <div className="d-flex justify-content-center align-items-center mt-4">
//         <Button
//           variant="primary"
//           onClick={handlePrevPage}
//           disabled={currentPage === 1}
//           style={{ backgroundColor: currentColor, marginRight: "5px" }}
//         >
//           <FaArrowLeft />
//         </Button>
//         <span>
//           Page {currentPage} of {Math.ceil(filteredLogs.length / logsPerPage)}
//         </span>
//         <Button
//           variant="primary"
//           onClick={handleNextPage}
//           disabled={indexOfLastLog >= filteredLogs.length}
//           style={{ backgroundColor: currentColor, marginLeft: "5px" }}
//         >
//           <FaArrowRight />
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default Log;

import React, { useState, useEffect } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useStateContext } from "../contexts/ContextProvider";
import shareService from "../services/shareService";

const Log = () => {
  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [totalLogs, setTotalLogs] = useState(0);
  const [loading, setLoading] = useState(false);
  const logsPerPage = 10;
  const skip = (currentPage - 1) * logsPerPage;
  const { currentColor, currentMode } = useStateContext();
  const [uid, setUid] = useState("");
  const fetchLogs = async () => {
    setLoading(true);
    try {
      let userData = "";
      const usedData = await localStorage.getItem("userData");
      if (usedData) {
        userData = JSON.parse(usedData);
        console.log(userData);
        setUid(userData._id);
      }
      let data = {
        start_date: startDate ? startDate.toISOString() : null,
        end_date: endDate ? endDate.toISOString() : null,
        skip: skip,
        uid: userData?._id || "",
      };
      if (userData.role === "superadmin") {
        data = {
          start_date: startDate ? startDate.toISOString() : null,
          end_date: endDate ? endDate.toISOString() : null,
          skip: skip,
          uid: "",
        };
      }

      const response = await shareService.userLogs(data);

      setLogs(response.logs_data);
      setTotalLogs(response.log_count);
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(async () => {
    await fetchLogs();
  }, [startDate, endDate, currentPage]);

  const handleNextPage = () => {
    if (currentPage * logsPerPage < totalLogs) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const getFileName = (fullPath) => {
    return fullPath.split("/").pop(); // Extracts the file name
  };
  function formatDate(isoString) {
    const date = new Date(isoString);

    // Extract date and time components
    const formattedDate = date.toISOString().split("T")[0]; // "YYYY-MM-DD"
    const formattedTime = date.toISOString().split("T")[1].split(".")[0]; // "HH:mm:ss"

    // Combine date and time
    return `${formattedDate} ${formattedTime}`;
  }

  return (
    <div
      className={`container ${
        currentMode === "dark" ? "bg-dark text-white" : "text-dark"
      }`}
      style={{ borderRadius: "10px", padding: "50px" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-4">
        <Form.Group className="d-flex align-items-center">
          <Form.Label className="mr-2">Start Date:</Form.Label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            className="form-control"
            isClearable
            placeholderText="Select start date"
          />
        </Form.Group>
        <Form.Group className="d-flex align-items-center">
          <Form.Label className="mr-2">End Date:</Form.Label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            className="form-control"
            isClearable
            placeholderText="Select end date"
          />
        </Form.Group>
        <span>
          Showing {skip + 1}-{Math.min(skip + logsPerPage, totalLogs)} of{" "}
          {totalLogs} logs
        </span>
      </div>
      {loading ? (
        <div className="text-center">Loading logs...</div>
      ) : (
        <div className="h-[60vh] overflow-y-auto">
          <Table
            striped
            bordered
            hover
            responsive
            className={`${
              currentMode === "dark" ? "table-dark" : "table-white"
            }`}
          >
            <thead>
              <tr>
                <th>S.No</th>
                <th>Client Name</th>
                <th>Folder Name</th>
                <th>File Name</th>
                <th>Server Address</th>
                <th>Message</th>
                <th>Created By</th>
                <th>Created On (Timestamp)</th>
              </tr>
            </thead>
            <tbody>
              {logs?.length > 0 ? (
                logs.map((log, index) => (
                  <tr key={index}>
                    <td>{skip + index + 1}</td>
                    <td>{log.clientName}</td>
                    <td>{log.folderName}</td>
                    <td className="tb-filename">
                      {getFileName(log.filename) || "-"}
                    </td>
                    <td>{log.serverAddress}</td>
                    <td>{log.message}</td>
                    <td>{log.createdBy}</td>
                    <td>{formatDate(log.createdOn)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No logs available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      )}
      <div className="d-flex justify-content-center align-items-center mt-4">
        <Button
          variant="primary"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          style={{ backgroundColor: currentColor, marginRight: "5px" }}
        >
          <FaArrowLeft />
        </Button>
        <span>
          Page {currentPage} of {Math.ceil(totalLogs / logsPerPage)}
        </span>
        <Button
          variant="primary"
          onClick={handleNextPage}
          disabled={skip + logsPerPage >= totalLogs}
          style={{ backgroundColor: currentColor, marginLeft: "5px" }}
        >
          <FaArrowRight />
        </Button>
      </div>
    </div>
  );
};

export default Log;
